import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import axios from "axios";
import severUrl from "../../api";

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        username: "",
      },
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitted: true });
    const { user } = this.state;
    if (user.username && user.password) {
      var bodyFormData = new FormData();
      bodyFormData.append("username", user.username);
      bodyFormData.append("password", user.password);
      axios
        .post(severUrl + `registration/login_user`, bodyFormData)
        .then((response) => {
          // console.log(response.data);
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
        });
    }
  }

  render() {
    const { registering } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
        <p style={{margin:"60px"}}></p>

        <h3>Job contact</h3>
        <span/>
        <div className="simple-text-md">I am opening for AI/Machine Learning job</div>
        <div className="simple-text-md">I would like to work remotely or onsite on US</div>
        <div className="simple-text-md">Please send JD or contact with me via email</div>
        <div className="simple-text-md">My mail id: </div>
        <a>htanloc994@gmail.com</a>

        <span/>
        <div className="simple-text-md">Thanks Sincerely</div>
        <div  className="simple-text-md">Ho Tan Loc (Mr.)</div>
      </>
    );
  }
}

function mapState(state) {
  const { registering } = state.registration;
  return { registering };
}

const actionCreators = {
  register: userActions.register,
};

const connectedRegisterPage = connect(mapState, actionCreators)(Service);
export { connectedRegisterPage as Service };
